import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import PrivacyPolicy from './PrivacyPolicy';
import HomePage from './components/HomePage';

export default function AppWrapper() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path='/home' element={<HomePage />} />
          <Route path='/privacy' element={<PrivacyPolicy />} />
          <Route path='/*' element={<App />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
